import { logEvent } from 'firebase/analytics';
import _ from 'lodash';
import { analytics } from '../firebase/firebase';
import { logError } from '../components/logger/sentryLogger';

export const captureGAEvents = (eventName, params) => {
  try {
    logEvent(analytics, _.capitalize(`WEB_${eventName}`), params);
  } catch (error) {
    logError(error, 'captureGAEvents Error', { eventName, params });
  }
};

export const captureAGIdentify = (userType) => {
  try {
    logEvent(analytics, _.capitalize(`WEB_${userType}_ACCOUNT_SETTINGS_ACCESS`), {
      screen: `${userType}_profile`,
      profile: userType
    });
  } catch (error) {
    logError(error, 'Posthog Error at capturePHIdentify');
  }
};
